import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeFaviconUrl extends ChangeBusinessDetails {
  type: string = 'ChangeFaviconUrl';
}
